/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_End_AtInputs */

const cs_form_end_at = /** @type {(inputs: Form_End_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konec`)
};

const en_form_end_at = /** @type {(inputs: Form_End_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

/**
* | output |
* | --- |
* | "End" |
*
* @param {Form_End_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_end_at = /** @type {((inputs?: Form_End_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_End_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_end_at(inputs)
	return cs_form_end_at(inputs)
});